import React from 'react';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../../Enums/PresentationMode';
import { editAgentBankAccountFormId } from '../EditAgentBankAccount';
import SecondaryButton from '../../../../../../Elements/ids/Buttons/SecondaryButton';
import ModalPrimaryButton from '../../../../../../Elements/ids/Buttons/ModalPrimaryButton';
import PrimaryButton from '../../../../../../Elements/ids/Buttons/PrimaryButton';

const EditAgentBankAccountButtons = ({ closeView, canSubmit, modalMode, closeError }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />

      {modalMode !== PresentationMode.Error ? (
        <ModalPrimaryButton
          text={formatMessage(Messages.common_save)}
          formId={editAgentBankAccountFormId}
          canSubmit={canSubmit}
        />
      ) : (
        <PrimaryButton text={formatMessage(Messages.common_ok)} onClickEvent={closeError} />
      )}
    </>
  );
};

export default EditAgentBankAccountButtons;
